var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3247",
  "data-name": "Group 3247",
  transform: "translate(-16 -280)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2293",
  "data-name": "Rectangle 2293",
  width: 16,
  height: 16,
  transform: "translate(16 280)",
  fill: "#afb6c0",
  opacity: 0.004
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M12.613,16a2,2,0,0,1-1.952-2.035,2.1,2.1,0,0,1,.392-1.224H7.988a2.125,2.125,0,0,1,.393,1.224A2,2,0,0,1,6.428,16a2,2,0,0,1-1.952-2.035,2.1,2.1,0,0,1,.393-1.224h-1.2a.664.664,0,0,1-.6-.385.715.715,0,0,1,.057-.729L4.555,9.2,3.449,3.626,3,1.4H1.672A.687.687,0,0,1,1,.7.687.687,0,0,1,1.672,0H3.544A.681.681,0,0,1,4.2.555l.1.5L16.328,1.1a.654.654,0,0,1,.506.248.71.71,0,0,1,.143.564L15.669,9.55a.67.67,0,0,1-.651.567l-9.451.017L5,11.343H16.326a.7.7,0,0,1,0,1.4H14.173a2.13,2.13,0,0,1,.392,1.224A2,2,0,0,1,12.613,16Zm0-2.661a.627.627,0,1,0,.6.626A.615.615,0,0,0,12.613,13.339Zm-6.185,0a.627.627,0,1,0,.6.626A.615.615,0,0,0,6.428,13.339ZM4.585,2.44,5.861,8.756l8.6-.015,1.073-6.264Z",
  transform: "translate(15 280)",
  fill: "#afb6c0"
}))));
export default __webpack_public_path__ + "static/media/Ord.39e66882.svg";
export { SvgComponent as ReactComponent };